import { render, staticRenderFns } from "./NewFundingModal.vue?vue&type=template&id=c4f1f74a&scoped=true&"
import script from "./NewFundingModal.vue?vue&type=script&lang=js&"
export * from "./NewFundingModal.vue?vue&type=script&lang=js&"
import style0 from "./NewFundingModal.vue?vue&type=style&index=0&id=c4f1f74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f1f74a",
  null
  
)

export default component.exports